@if (mCompanyDetailData?.id || mcId) {
  <ng-container>
    <div class="details-card mb-4">
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4">
        <dl>
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <dt>Company Name</dt>
              <dd
                [class.link-edit]="isAdmin"
                (click)="
                  isAdmin
                    ? openTemplate(updateMCTemplateRef, 'company_name')
                    : null
                "
              >
                {{ mCompanyDetailData?.company_name }}
              </dd>
            </div>
          </div>
        </dl>

        <div>
          <dl>
            <dt>Company Address</dt>
            <dd
              [class.link-edit]="isAdmin"
              (click)="
                isAdmin ? openTemplate(updateMCTemplateRef, 'address') : null
              "
            >
              {{ mCompanyDetailData?.address?.full_address }}
            </dd>

            @if (isAdmin && !mCompanyDetailData?.address?.full_address) {
              <div
                class="rounded border shadow p-2 mb-2 text-center hover"
                role="button"
                (click)="openTemplate(updateMCTemplateRef, 'address')"
              >
                <i class="fa-solid fa-plus"></i>
              </div>
            }
          </dl>
        </div>
        @if (isAdmin) {
          <div>
            <!--the outer div is necessary for correct padding and matching other div dls-->
            <dl>
              <dt>Additional Information</dt>
              <dd
                class="gt-multi-line"
                [class.link-edit]="isAdmin"
                (click)="
                  isAdmin
                    ? openTemplate(updateMCTemplateRef, 'information')
                    : null
                "
              >
                {{ mCompanyDetailData?.information }}
              </dd>
              @if (isAdmin && !mCompanyDetailData?.information) {
                <div
                  class="rounded border shadow p-2 mb-2 text-center hover"
                  role="button"
                  (click)="openTemplate(updateMCTemplateRef, 'information')"
                >
                  <i class="fa-solid fa-plus"></i>
                </div>
              }
            </dl>
          </div>
        }
        <div>
          <dl>
            <dt class="mb-1">Contacts</dt>

            <dd class="mb-2">
              @for (
                contact of mCompanyDetailData?.contacts;
                track contact;
                let i = $index
              ) {
                <div
                  class="d-flex flex-column flex-wrap border rounded p-2 mb-2 shadow"
                >
                  <div class="d-flex justify-content-between">
                    <div class="fw-semibold mb-2">
                      {{ contact?.first_name }} {{ contact?.last_name }}
                    </div>
                    @if (isAdmin) {
                      <div (click)="removeContact(i)">
                        <i
                          class="fs-5 fa-solid fa-circle-minus text-danger"
                        ></i>
                      </div>
                    }
                  </div>
                  <div class="d-flex mb-2">
                    {{ contact?.email }}
                  </div>
                  @if (contact?.mobile_number) {
                    <div class="d-flex mb-2">
                      {{ contact?.mobile_number }}
                    </div>
                  }
                  <div class="d-flex justify-content-between">
                    <div>
                      <a href="mailto:{{ contact?.email }}">
                        <button class="btn btn-sm btn-primary">Email</button>
                      </a>
                    </div>
                    <div>
                      <a href="tel:+{{ contact?.mobile_number }}">
                        <button class="btn btn-sm btn-success">Call</button>
                      </a>
                    </div>
                  </div>
                </div>
              }
            </dd>
            @if (isAdmin) {
              <div
                class="rounded border shadow p-2 mb-2 text-center hover"
                role="button"
                (click)="openTemplate(updateMCTemplateRef, 'contacts')"
              >
                <i class="fa-solid fa-plus"></i>
              </div>
            }
          </dl>
        </div>
      </div></div
  ></ng-container>
} @else {
  <div class="fw-bold mb-2">Add New Monitoring Company</div>
  <div class="row row-cols-1 row-cols-lg-2">
    <div class="col">
      <form [formGroup]="companyForm">
        @if (currentStep === 1) {
          <div class="row row-cols-2 gy-2 mb-2">
            <div class="col">
              <button
                type="button"
                class="btn btn-dark btn-lg w-100"
                (click)="redirectToList()"
              >
                Cancel
              </button>
            </div>
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-primary w-100"
                [disabled]="createMCDisabling()"
                (click)="currentStep = 2"
              >
                Next
              </button>
            </div>
          </div>
          @if (companyForm.value.company_name && blurCalledDict?.mc) {
            <dl class="p-2">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <dt>Company Name</dt>
                  <dd>
                    {{ companyForm.value.company_name }}
                  </dd>
                </div>
                <div>
                  <span (click)="editField('mc')">
                    <i
                      class="fa-solid fa-pen-to-square md-font-size text-secondary"
                    ></i
                  ></span>
                </div>
              </div>
            </dl>
          }
          @if (!blurCalledDict?.mc || !companyForm.value.company_name) {
            <div class="input-group my-2">
              <div class="form-floating">
                <input
                  class="form-control"
                  type="text"
                  id="mcNameField"
                  formControlName="company_name"
                  autocomplete="off"
                  placeholder="Company Name"
                  maxlength="60"
                  autofocus
                  (blur)="
                    companyForm.value.company_name
                      ? onBlurEventTrigger('mc', 'mcNameField')
                      : null
                  "
                />
                <label for="company_name">Company Name</label>
              </div>
              @if (companyForm.value.company_name) {
                <span class="input-group-text" (click)="editField('mc')">
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
          }
          <gtapp-address-lookup
            [addressForm]="addressForm"
            placeholder="Lookup Address (Optional)"
          >
          </gtapp-address-lookup>
        }
        @if (currentStep === 2) {
          <div class="row row-cols-2 mb-2">
            <div class="col">
              <!-- enter key on cleint select calling these buttons. Added type to avoid that-->
              <button
                type="button"
                class="btn btn-dark btn-lg w-100"
                (click)="currentStep = 1"
              >
                Back
              </button>
            </div>
            <div class="col">
              <!-- enter key on cleint select calling these buttons. Added type to avoid that-->
              <button
                type="button"
                class="btn btn-primary btn-lg w-100"
                (click)="currentStep = 3"
              >
                Next
              </button>
            </div>
          </div>
          @if (companyForm.value.information && blurCalledDict?.information) {
            <dl class="p-2">
              <!--additionala information-->
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <dt>Additional Information</dt>
                </div>
                <div>
                  <span (click)="editField('information')">
                    <i
                      class="fa-solid fa-pen-to-square md-font-size text-secondary"
                    ></i
                  ></span>
                </div>
              </div>
              <dd class="gt-multi-line">
                {{ companyForm.value.information }}
              </dd>
            </dl>
          }
          @if (!blurCalledDict?.information || !companyForm.value.information) {
            <div class="input-group my-2">
              <div class="input-group">
                <div class="col">
                  <textarea
                    cols="20"
                    rows="4"
                    wrap="hard"
                    class="form-control"
                    type="text"
                    id="mcInfoField"
                    formControlName="information"
                    autocomplete="off"
                    placeholder="Additional Information (Optional)"
                    maxlength="500"
                    autofocus
                    (blur)="
                      companyForm.value.information
                        ? onBlurEventTrigger('information', 'mcInfoField')
                        : null
                    "
                  ></textarea>
                </div>
                @if (companyForm.value.information) {
                  <span
                    class="input-group-text"
                    (click)="editField('information')"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </span>
                }
              </div>
            </div>
          }
        }
        @if (currentStep === 3) {
          <div class="row row-cols-2 gy-2 mb-4">
            <div class="col">
              <!-- enter key on cleint select calling these buttons. Added type to avoid that-->
              <button
                type="button"
                class="btn btn-lg btn-dark w-100"
                (click)="currentStep = 2"
              >
                Back
              </button>
            </div>
            <div class="col">
              <!-- enter key on cleint select calling these buttons. Added type to avoid that-->
              <button
                type="button"
                class="btn btn-lg btn-primary w-100"
                [disabled]="createMCDisabling()"
                (click)="createMC()"
              >
                Submit
              </button>
            </div>
          </div>
          <ng-template
            *ngTemplateOutlet="
              contactTemplate;
              context: { contacts: contactDataList }
            "
          ></ng-template>
        }
      </form>
    </div>

    <div class="col">
      <div class="d-none d-md-block">
        @if (addressForm.value?.latitude && addressForm.value?.longitude) {
          <gtapp-map-leaflet
            [latLon]="{
              lat: addressForm.value?.latitude,
              lon: addressForm.value?.longitude,
            }"
            mapId="companyLocation"
          ></gtapp-map-leaflet>
        }
      </div>
    </div>
  </div>
}

<ng-template #updateMCTemplateRef let-updateMCTemplateRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      Update
      <span class="float-end" (click)="updateMCTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <ng-container>
        <form [formGroup]="companyForm" appFormEnterAction>
          @if (data?.field == "company_name") {
            <div class="input-group">
              <div class="form-floating">
                <input
                  class="form-control"
                  type="text"
                  id="mcNameField"
                  formControlName="company_name"
                  autocomplete="off"
                  placeholder="Company Name"
                  maxlength="60"
                  autofocus
                />
                <label for="company_name">Company Name</label>
              </div>
              @if (companyForm.value.company_name) {
                <span class="input-group-text" (click)="editField('mc')">
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
          }
          @if (data?.field == "information") {
            <div class="input-group">
              <div class="col">
                <textarea
                  cols="20"
                  rows="4"
                  wrap="hard"
                  class="form-control"
                  type="text"
                  id="mcInfoField"
                  formControlName="information"
                  autocomplete="off"
                  placeholder="Additional Information (Optional)"
                  maxlength="500"
                  autofocus
                ></textarea>
              </div>
              @if (companyForm.value.information) {
                <span
                  class="input-group-text"
                  (click)="editField('information')"
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
          }
          @if (data?.field == "address") {
            <gtapp-address-lookup [addressForm]="addressForm">
            </gtapp-address-lookup>
          }
        </form>
        @if (data?.field == "contacts") {
          <div>
            <ng-template
              *ngTemplateOutlet="
                contactTemplate;
                context: { contacts: contactDataList }
              "
            ></ng-template>
          </div>
        }
        @if (data?.field !== "contacts" || contactDataList?.length) {
          <div class="row g-2 my-3">
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-darkn-light w-100"
                (click)="updateMCTemplateRef.close()"
              >
                Cancel
              </button>
            </div>
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-primary w-100"
                [disabled]="
                  data?.field == 'contacts'
                    ? false
                    : data?.field == 'address'
                      ? !addressForm.valid
                      : !companyForm.valid
                "
                (click)="updateMC(data?.field); updateMCTemplateRef.close()"
              >
                Submit
              </button>
            </div>
          </div>
        }
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #contactTemplate let-contactTemplate="dialogRef" let-data>
  @if (openContactForm || !contactDataList?.length) {
    <form [formGroup]="contactForm" appFormEnterAction>
      <div class="row row-cols-1 g-2 mb-4">
        <div class="form-floating">
          <input
            class="form-control"
            type="text"
            id="firstName"
            (keyup.enter)="shiftFocus('lastName')"
            formControlName="first_name"
            autocomplete="off"
            [maxlength]="150"
            placeholder="First Name"
          />
          <label for="firstName">First Name</label>
        </div>

        <div class="form-floating">
          <input
            class="form-control"
            type="text"
            id="lastName"
            (keyup.enter)="shiftFocus('email')"
            formControlName="last_name"
            autocomplete="off"
            [maxlength]="150"
            placeholder="Last Name"
          />
          <label for="lastName">Last Name</label>
        </div>
        <div class="form-floating">
          <input
            class="form-control"
            type="email"
            id="email"
            [class.is-invalid]="
              contactForm.controls['email'].invalid &&
              contactForm.controls['email'].touched
            "
            (keyup.enter)="shiftFocus('phone')"
            formControlName="email"
            autocomplete="off"
            placeholder="Email"
          />
          <label for="email">Email</label>
        </div>
        @if (dupContactCheck()) {
          <div>
            <p class="text-danger">Email address already added</p>
          </div>
        }
        <div class="form-floating">
          <input
            class="form-control"
            type="tel"
            inputmode="numeric"
            pattern="[0-9]*"
            minlength="7"
            maxlength="10"
            id="phone"
            formControlName="mobile_number"
            autocomplete="off"
            placeholder="Telephone"
            (input)="mobileNumberCheck()"
          />
          <label for="phone">Telephone</label>
          @if (
            contactForm.controls["mobile_number"].invalid &&
            contactForm.controls["mobile_number"].touched
          ) {
            <div>
              <p class="text-danger">Mobile should be a 10-digit number</p>
            </div>
          }
        </div>
      </div>
      <div class="row g-2 my-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-darkn-light w-100"
            (click)="
              contactForm.reset();
              contactDataList?.length ? (openContactForm = false) : null
            "
          >
            {{ contactDataList?.length ? "Cancel" : "Clear" }}
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-primary w-100"
            [disabled]="!contactForm.valid || dupContactCheck()"
            (click)="
              contactDataList.push(contactForm.value); openContactForm = false
            "
          >
            Add Contact
          </button>
        </div>
      </div>
    </form>
  }
  @if (contactDataList?.length) {
    <div>
      <dl>
        <div class="d-flex align-items-center mb-3">
          <div class="flex-grow-1">
            <dt>Contacts</dt>
          </div>
          <div class="d-flex align-items-center">
            <span
              role="button"
              (click)="openContactForm = true; contactForm.reset()"
            >
              <i class="fa-solid fa-plus md-font-size text-secondary"></i>
            </span>
          </div>
        </div>
        <dd class="p-2">
          <table class="table table-hover">
            <tbody>
              @for (contact of contactDataList; track contact; let i = $index) {
                <tr class="cursor-pointer">
                  <td>
                    <div class="d-flex">
                      <div class="d-flex align-items-center me-3">
                        <i class="fa-solid fa-address-book fa-2x"></i>
                      </div>
                      <div class="flex-grow-1">
                        {{ contact?.first_name }} {{ contact?.last_name }}
                        <div class="small-font">
                          {{ contact?.email }}
                        </div>
                        <div class="small-font">
                          {{ contact?.mobile_number }}
                        </div>
                      </div>
                      <div (click)="contactDataList?.splice(i, 1)">
                        <i
                          class="fs-5 fa-solid fa-circle-minus text-danger"
                        ></i>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </dd>
      </dl>
    </div>
  }
</ng-template>
